module.exports = __webpack_public_path__ + "03_medium_black.cd9fa48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_medium_black.png
// module id = o2KR
// module chunks = 0